var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchorLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1498 11.8647L23.6895 19.7485C21.6229 22.2705 17.9032 22.6396 15.3813 20.573C12.8593 18.5064 12.4902 14.7867 14.5568 12.2648L15.5932 11H13.0075C10.2434 14.3762 10.7383 19.3541 14.1136 22.12C17.4899 24.8866 22.4698 24.3925 25.2364 21.0162L31.6968 13.1323C34.4635 9.75604 33.9693 4.77618 30.593 2.00951C27.2167 -0.757165 22.2368 -0.262974 19.4702 3.11332L17.9241 5H20.5098L21.0171 4.38096C23.0837 1.85903 26.8034 1.48989 29.3253 3.55647C31.8473 5.62304 32.2164 9.34276 30.1498 11.8647Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8197 17.7811L18.9306 17.6458C20.9972 15.1238 20.628 11.4041 18.1061 9.33753C15.5842 7.27096 11.8645 7.6401 9.79788 10.162L3.33754 18.0459C1.27096 20.5678 1.6401 24.2875 4.16203 26.3541C6.5976 28.3499 10.1503 28.0739 12.2523 25.7811H14.8499L14.0172 26.7972C11.2505 30.1735 6.27067 30.6677 2.89438 27.901C-0.481907 25.1344 -0.976099 20.1545 1.79058 16.7782L8.25092 8.89438C11.0176 5.51809 15.9975 5.0239 19.3737 7.79058C22.3893 10.2617 23.1057 14.4984 21.2531 17.7811H18.8197Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorLink);
export default __webpack_public_path__ + "static/media/anchor_link.8d83b1517ea5288515d3c8fd85aaf2d2.svg";
export { ForwardRef as ReactComponent };